export interface AmplitudeReturn<T> {
  promise: Promise<T>;
}
